import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Layout, Menu, Card, Typography, Space } from "antd";
import { ShopOutlined, ProductOutlined, AreaChartOutlined } from "@ant-design/icons";
import { IonIcon } from "@ionic/react";
import { fastFood, giftOutline, imageOutline, radioOutline, videocamOutline } from "ionicons/icons";
import metaData from "../../data/metaData";
import { useTranslation } from "react-i18next";
import log from "../../utils/log";
import useAuthStore from "../../states/useAuth";
import useGeneralStore from "../../states/useGeneral";
import useRequestStore from "../../states/useRequest";
import useShopStore from "../../states/useShop";
import useUserStore from "../../states/useUser";
import useCompanyStore from "../../states/useCompany";

const { Sider } = Layout;
const { Text } = Typography;

const SiderComponent = ({ collapsed, onCollapse }) => {
  const history = useHistory();
  const location = useLocation();

  const { auth, user } = useAuthStore();
  const { company } = useCompanyStore();
  const { newCompany, newBrand, newShop, requestsCache, singleRequestCache } = useRequestStore();
  const { shopsCache, singleShopCache } = useShopStore();
  const { usersCache, singleUserCache } = useUserStore();

  const items = [
    {
      key: "/approver/shop/request",
      label: "Shop",
      icon: <ShopOutlined />,
    },
    {
      key: "/approver/product/request",
      label: "Product",
      icon: <ProductOutlined />,
    },
    // {
    //   key: "/approver/takeaway",
    //   label: "Takeaway",
    //   icon: <IonIcon icon={fastFood} />,
    // },
    {
      key: "/approver/report/distribute",
      label: "Report",
      icon: <AreaChartOutlined />,
    },
    {
      key: "marketing",
      label: "Marketing",
      type: "group",
      children: [
        {
          key: "/approver/welcome",
          label: "Welcome",
          icon: <IonIcon icon={giftOutline} />,
        },
        {
          key: "/approver/ad",
          label: "Ad",
          icon: <IonIcon icon={imageOutline} />,
          children: [
            {
              key: "/approver/ad/banner",
              label: "Banner",
              icon: <IonIcon icon={imageOutline} />, // Example icon
            },
            // {
            //   key: "/approver/ad/video",
            //   label: "Video",
            //   icon: <IonIcon icon={videocamOutline} />, // Example icon
            // },
          ],
        },
        {
          key: "/approver/pushNotification",
          label: "Push Notification",
          icon: <IonIcon icon={radioOutline} />,
        },
      ],
    },
  ];

  // Use useMemo to calculate the active key based on the current pathname
  const activeKey = useMemo(() => {
    const { pathname } = location;
    log.debug(pathname);

    for (let item of items) {
      if (pathname.includes(item.key)) {
        log.debug(item.key);
        return item.key;
      }
    }
  }, [location.pathname]); // Only recalculate when pathname changes

  const onClickMenuItem = (e) => {
    log.debug(e);
    history.push(e.key);
  };

  return (
    <Sider
      collapsible={false}
      collapsed={collapsed}
      onCollapse={onCollapse}
      theme="light"
      style={{
        overflow: "auto",
        height: "100vh",
        position: "fixed",
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: "thin",
        scrollbarColor: "unset",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center", // Align items vertically centered
          justifyContent: "start", // Align items horizontally start
          padding: "16px",
          fontWeight: "bold",
          fontSize: "1.25rem",
          borderRight: "1px solid var(--ion-color-step-100)", // Makeup for the missing border
        }}
        onClick={() => {
          log.debug({
            auth,
            user,
            company,
            newCompany,
            newBrand,
            newShop,
            shopsCache,
            singleShopCache,
            requestsCache,
            singleRequestCache,
          });
        }}
      >
        <img
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "5px",
          }}
          src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
          alt="Logo" // Add alt text for better accessibility
        />
        <span>Pearl</span>
      </div>
      <Menu
        mode="inline"
        onClick={onClickMenuItem}
        items={items}
        defaultSelectedKeys={[activeKey]}
        defaultOpenKeys={[activeKey]}
        selectedKeys={[activeKey]}
        style={{ height: "calc(100% - 82px)" }} // minus height of logo section
      />
    </Sider>
  );
};

export default SiderComponent;
